import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { useForm } from "react-hook-form";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import { inRange, isEmpty, lowerCase, startCase } from "lodash";
import { t } from "i18next";
import { formatWithCommas, validationRules ,bankType} from "../Utils/constants";
import { Form,Button } from "react-bootstrap";
import BonusSelect from "../component/BonusSelect";
import { isMobile } from "react-device-detect";
import { CopyToClipboard } from "react-copy-to-clipboard";
import iconBkash from "../assets/images/bkash.png";
import iconRocket from "../assets/images/rocket.png";
import iconNagad from "../assets/images/nagad.png";
import iconEth from "../assets/images/eth.svg";
import iconBtc from "../assets/images/btc.svg";
import iconUpay from "../assets/images/upay.png";
import phonepay from "../assets/images/phonepay.png";
import googlepay from "../assets/images/googlepay.png";
import paytm from "../assets/images/paytm.png";
import bankImg from "../assets/images/bank.png";

const paymentIcons = {
  bkash: iconBkash,
  nagad: iconNagad,
  rocket: iconRocket,
  eth: iconEth,
  btc: iconBtc,
  upay: iconUpay,
  phonepay: phonepay,
  googlepay: googlepay,
  paytm: paytm,
};
const Deposit = () => {
   const getPaymentIcon = (bankName) => {
  const name = bankName?.toLowerCase() || "";

  const key = Object.keys(paymentIcons).find((item) =>
    name.includes(item)
  );

  return key ? paymentIcons[key] : bankImg;
};
 const { offerCode } = useParams();
  const [offer, setOffer] = useState("");
  const [offerId, setOfferId] = useState("");
  const [image, setImage] = useState("");
  const [show, setShow] = useState(false);
  const [bank, setBank] = useState([]);
  const [id, setId] = useState("");

  const [dataOffer, setDataOffer] = useState([]);

  const [isCopied, setCopied] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCopied(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [isCopied]);


  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const setLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.setLoader;
  });
  const handleSelectChange = (value) => {
    setOffer(value?.title);
    setOfferId(value?._id);
    setLimit({
      minDeposit: value?.minimumDeposite,
      maxDeposit: value?.maximumDeposite,
    });
  };

  const [limit, setLimit] = useState(
    profileData?.limitSetting?.length > 0
      ? profileData?.limitSetting[0]
      : {
        minDeposit: "100",
        maxDeposit: "30000",
      },
  );

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
  });
  const uploadImage = async (obj) => {
    let form = new FormData();
    form.append("TransactionFile", obj);
    const { status, data } = await apiPost(apiPath.reciptUpload, form);
    if (status == 200) {
      return data?.path;
    } else {
      return false;
    }
  };

  const [paymentType, setPaymentType] = useState("offline");

  useEffect(() => {
    if (profileData.defaultPaymentType) {
      setPaymentType(profileData.defaultPaymentType);
    }
  }, [profileData.defaultPaymentType]);

  const [selectedMethod, setSelectedMethod] = useState("");


  useEffect(() => {
    if (paymentType === "online") {
      const defaultMethod = bankType.find(
        (m) => m.bank_name.toLowerCase() === "bkash"
      );

      if (defaultMethod) {
        setSelectedMethod(defaultMethod.bank_name);
        setValue("bank", defaultMethod._id); // react-hook-form
      }
    }
  }, [paymentType, setValue]);


  const onSubmit = async (body) => {
    setLoader(true);

    try {
      let imageCheck = "";

      if (image) {
        imageCheck = await uploadImage(image);
      }

      const payload = {
        amount: body?.amount,
        offer: offerId,
        bank: id,
        AccountName: body?.accountName,
        BankAccount: body?.bankAccount,
      };

      if (paymentType === "online") {
        payload.transactionType = selectedMethod.toUpperCase();
        payload.payin = true;
      } else {
        payload.transactionType = paymentType;
        payload.TransactionId = body?.transactionId;
        payload.TransactionFile = image ? imageCheck : "";
      }

      const { status, data } = await apiPost(apiPath.depositAmount, payload);

      if (status !== 200) {
        return toast.error(data?.message || "Something went wrong");
      }

      // Online Payment
      if (
        paymentType === "online" &&
        data?.results?.payment_url
      ) {
        window.location.href = data.results.payment_url;
        return;
      }

      // Offline Payment
      if (data?.results) {
        toast.success(data?.message);
        // amounutRefresh();
        // getProfileData();
        setImage("");
        reset();
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  const getBankDetail = async (body) => {
    setId(body);
    const { status, data } = await apiPost(apiPath.getBankDetail, {
      bank: body,
    });
    if (status == 200) {
      if (data?.success) {
        setValue("accountName", data?.results?.bankDetail?.account_name);
        setValue("bankAccount", data?.results?.bankDetail?.account_number);
      }
    }
  };
  const getBank = async () => {
    const { status, data } = await apiPost(apiPath.getBank, {
      type: "deposit",
    });
    if (status == 200) {
      if (data?.success) {
        setBank(
          paymentType === "online"
            ? bankType
            : data?.results?.bankList || []
        );
        if (data?.results?.bankList?.length > 0) {
          setSelectedMethod(lowerCase(data?.results?.bankList[0]?.bank_name));
          getBankDetail(data?.results?.bankList[0]?._id);
        }
      }
    }
  };
  const getFilteredOfferList = (count, list) => {
    const depositKeysToRemove = [
      "OnFirstDeposit",
      "OnSecondDeposit",
      "OnThirdDeposit",
      "OneFourthDeposit",
    ];

    const keysToRemove = depositKeysToRemove.slice(0, count);
    return list.filter((offer) => !keysToRemove.includes(offer.offerOn));
  };
  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getPromotional, {
      category: "Deposit",
    });
    if (status == 200) {
      if (data?.success) {
        let result = data?.results?.offerList?.filter((res) => {
          return res?.category == "Deposit";
        });
        let updated = getFilteredOfferList(
          profileData?.userDepositCount || 0,
          result,
        );
        let find = updated?.find((res) => {
          return res?._id == offerCode;
        });
        if (!isEmpty(find)) {
          setOffer(find?.title);
          setOfferId(find?._id);
          handleSelectChange(find);
        }
        if (updated?.length > 0) {
          setDataOffer(updated);
        }
      }
    }
  };

  useEffect(() => {
    if (paymentType) {
      getBank();
      setValue("depositType", "online");
    }

  }, [paymentType]);

  useEffect(() => {
    getData();
  }, [offerCode, profileData]);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(watch("bankAccount"))
      .then(() => {
        toast.success("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  const maskBankAccount = (value = "") => {
    if (!value) return "";
    const first4 = value.slice(0, 4);
    const masked = "*".repeat(Math.max(0, value.length - 4));
    return first4 + masked;
  };

 return (
    <div className="bank-detail-card deposit-card v-card v-sheet theme--light elevation-0">
      <div>

        <div className="row breakpoint no-gutters align-end px-8 pt-4">
          {/* <div
            _ngcontent-serverapp-c684031653
            className="menu-box ng-tns-c684031653-19"
          >
            <div
              _ngcontent-serverapp-c684031653
              className="title ng-tns-c684031653-19"
            >
              <h2
                _ngcontent-serverapp-c684031653
                className="ng-tns-c684031653-19"
              >
                <span
                 
                  _ngcontent-serverapp-c684031653
                  className="input-field-label ma-0 text-capitalize d-block pb-1"
                >
                  Deposit Channel
                </span>
              </h2>
            </div>
            <div
              _ngcontent-serverapp-c684031653
              className="check-group ng-tns-c684031653-19"
            >


  <ul className="col3">
  <li
    className="payment-option"
    onClick={() => setPaymentType("offline")}
  >
    <input
      type="radio"
      value="offline"
      checked={paymentType === "offline"}
      onChange={() => setPaymentType("offline")}
    />
    <label>
      <span>Auto Pay</span>
    </label>
  </li>

  <li
    className="payment-option"
    onClick={() => setPaymentType("online")}
  >
    <input
      type="radio"
      value="online"
      checked={paymentType === "online"}
      onChange={() => setPaymentType("online")}
    />
    <label>
      <span>Okay Pay</span>
    </label>
  </li> 
</ul>
            </div>
          </div> */}
          
          <div className="col col-auto">
            <div className="hidden-md-and-up">
              <label className="input-field-label ma-0 text-capitalize d-block pb-1">
                {t("PaymentMethods")}
              </label>
            </div>
            <div className="hidden-sm-and-down">
              <label className="input-field-label ma-0 text-capitalize d-block pb-1">
                {t("DepositOptions")}
              </label>
            </div>
            <div className="row py-2 mb-3 no-gutters" style={{ gap: "0.5rem" }}>
              {bank.map((method) => (
                <div className="col col-auto">
                  <button

                    onClick={() => {
                      if (paymentType === "online") {
                        setSelectedMethod(method.bank_name);
                      } else {
                        getBankDetail(method._id);
                        setSelectedMethod(method.bank_name);
                      }
                    }}
                    key={method?._id}
                    type="button"
                    className={`${selectedMethod === method.bank_name
                        ? "active-gateway-button v-btn--active"
                        : ""
                      } v-btn v-btn--outlined theme--light v-size--default pa-2 gateway-button mobile-paymentMethod`}
                    style={{ height: "100%", width: "100px" }}
                  >
                    <span
                      style={{ display: "flex", flexDirection: "column" }}
                      className="v-btn__content"
                    >
                      <img
                        style={{ width: "35px", marginBottom: "5px" }}
                         src={getPaymentIcon(method?.bank_name)}
                      />
                      <span style={{ fontSize: "9px" }}>
                        {startCase(method?.bank_name)}
                      </span>
                    </span>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)} className="v-form">
          <div className="row breakpoint no-gutters align-end px-8 pt-2" >
            <div className="col-md-6 col">
              <div className="mobile">
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">
                    <label
                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                      style={{ float: "left" }}
                    >
                      {t("Deposit_Type")}
                    </label>
                  </div>
                  <div className="col col-12">
                    <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div className="v-input__control">
                        <div className="v-input__slot">
                          <fieldset aria-hidden="true">
                            <legend style={{ width: "0px" }}>
                              <span className="notranslate">​</span>
                            </legend>
                          </fieldset>
                          <div className="v-text-field__slot">
                            <select
                              {...register("depositType", {
                                required: {
                                  value: true,
                                  message: t("Select_Deposit_Type"),
                                },
                              })}
                              id="depositType"
                            >
                              <option value="">{t("Select_Deposit_Type")}</option>
                              <option value="online" security="true">
                                {t("Online_Transfer")}
                              </option>
                            </select>
                            {errors?.depositType?.message && (
                              <div class="transaction-errMsg text-danger depositMsg">
                                {errors?.depositType?.message}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
          <div className="row breakpoint no-gutters align-end px-8 pt-2" style={{ display: `none` }}>
            <div className="col-md-6 col">
              <div className="mobile">
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">
                    <label
                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                      style={{ float: "left" }}
                    >
                      {t("Account_Name")}
                    </label>
                  </div>
                  <div className="col col-12">
                    <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div className="v-input__control">
                        <div className="v-input__slot">
                          <fieldset aria-hidden="true">
                            <legend style={{ width: "0px" }}>
                              <span className="notranslate">​</span>
                            </legend>
                          </fieldset>
                          <div className="v-text-field__slot">
                            <input
                              autoComplete="new-password"
                              id="input-608"
                              type="text"
                              {...register("accountName")}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
 {paymentType !== "online" && !isEmpty(watch("bankAccount")) && (
          <div className="row breakpoint no-gutters align-end px-8 pt-2">
            <div className="col-md-6 col">
              <div className="mobile">
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">
                    <label
                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                      style={{ float: "left" }}
                    >
                      {t("Bank_Account")}
                    </label>
                  </div>
                  <div className="col col-12">
                    <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div className="v-input__control">
                        <div className="v-input__slot">
                          <fieldset aria-hidden="true">
                            <legend style={{ width: "0px" }}>
                              <span className="notranslate">​</span>
                            </legend>
                          </fieldset>
                          <div className="v-text-field__slot">
                            <input
                              autoComplete="new-password"
                              id="input-608"
                              type="tel"
                              value={watch("bankAccount")}
                              {...register("bankAccount")}
                              disabled
                            />
                            <div
                        className="input-group-btn"
                        style={{
                          position: "absolute",
                          right: "0",
                          top: "-10",
                          bottom: "0px",
                          filter: `invert(1)`,
                        }}
                      >
                        <span
                          className="btn btn-outline-primary"
                          style={{
                            backgroundColor: "transparent",
                            border: "0",
                            padding: "8px",
                            paddingTop: "0px",
                            height: "72%",
                          }}
                        >
                          <CopyToClipboard
                            text={getValues("bankAccount")}
                            onCopy={() => setCopied(true)}
                          >
                            <Button
                              className="copy-btn"
                              style={{
                                fontSize: `13px`,
                                padding: `5px`,
                                backgroundColor: `#005dac`,
                                color: `#fff`,
                              }}
                            >
                              {isCopied ? "Copied!" : "Copy"}
                            </Button>
                          </CopyToClipboard>
                        </span>
                      </div>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>)}
           {paymentType !== "online" && (
            <>
          <div className="row breakpoint no-gutters align-end px-8 pt-2">
            <div className="col-md-6 col">
              <div className="mobile">
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">
                    <label
                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                      style={{ float: "left" }}
                    >
                      {t("Transaction_ID")}
                    </label>
                  </div>
                  <div className="col col-12">
                    <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div className="v-input__control">
                        <div className="v-input__slot">
                          <fieldset aria-hidden="true">
                            <legend style={{ width: "0px" }}>
                              <span className="notranslate">​</span>
                            </legend>
                          </fieldset>
                          <div className="v-text-field__slot">
                            <input
                              autoComplete="new-password"
                              id="input-608"
                              type="text"
                              {...register("transactionId", {
                                required: {
                                  value: true,
                                  message: t("enter_Transaction_ID"),
                                },
                                pattern: {
                                  value: validationRules.removeWhitespace,
                                  message: t(
                                    "PleaseEnterOnlyNumberOrCharacter",
                                  ),
                                },
                              })}
                            />
                          </div>
                        </div>
                        {errors.transactionId &&
                          errors.transactionId.message && (
                            <div className="v-text-field__details">
                              <div
                                className="v-messages theme--light error--text"
                                role="alert"
                              >
                                <div className="v-messages__wrapper">
                                  <div className="v-messages__message">
                                    {errors.transactionId.message}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="row breakpoint no-gutters align-end px-8 pt-2">
            <div className="col-md-6 col">
              <div className="mobile">
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">
                    <label
                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                      style={{ float: "left" }}
                    >
                      {t("Upload_Receipt")}
                    </label>
                  </div>
                  <div className="col col-12">
                    <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div className="v-input__control">
                        <input
                          autoComplete="new-password"
                          id="input-608"
                          placeholder={t("Transaction_ID")}
                          type="file"
                          accept="image/png, image/jiffy, image/jpeg, image/jpg"
                          onChange={(e) => {
                            setImage(e.target.files[0]);
                          }}
                        />

                        {image !== "" && (
                          <button
                            style={{ marginTop: "10px" }}
                            onClick={() => setImage("")}
                            type="submit"
                            className="theme-button depo-width black--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default deposit-btn buttonPrimary"
                          >
                            <span className="v-btn__content">
                              {t("Remove")}
                            </span>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div></>)}
          <div className="row breakpoint no-gutters align-end px-8 pt-4">
            <div className="col-md-6 col">
              <div className="mobile">
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">
                    <label
                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                      style={{ float: "left" }}
                    >
                      {t("DepositAmount")}
                      <span className="red--text ml-1">*</span>
                    </label>
                  </div>

                  <div className="col col-12">
                    <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div className="v-input__control">
                        <div className="v-input__slot">
                          <fieldset aria-hidden="true">
                            <legend style={{ width: "0px" }}>
                              <span className="notranslate">​</span>
                            </legend>
                          </fieldset>
                          <div className="v-text-field__slot">
                            <input
                              autoComplete="new-password"
                              id="input-608"
                              placeholder={`Min ৳ ${formatWithCommas(
                                limit?.minDeposit,
                              )}- Max ৳ ${formatWithCommas(limit?.maxDeposit)}`}
                              type="text"
                              {...register("amount", {
                                required: {
                                  message: t("PleaseEnterAmount"),
                                },
                                pattern: {
                                  value: /^[0-9]*$/,
                                  message: t("PleaseEnterValidNumber"),
                                },
                                validate: (value) => {
                                  if (
                                    !inRange(
                                      value,
                                      limit?.minDeposit,
                                      limit?.maxDeposit,
                                    )
                                  ) {
                                    return `Deposite amount should be in range of ${limit?.minDeposit} - ${limit?.maxDeposit}`;
                                  } else {
                                    return true;
                                  }
                                },
                              })}
                            />
                          </div>
                        </div>
                        {errors.amount && errors.amount.message && (
                          <div className="v-text-field__details">
                            <div
                              className="v-messages theme--light error--text"
                              role="alert"
                            >
                              <div className="v-messages__wrapper">
                                <div className="v-messages__message">
                                  {errors.amount.message}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pb-2 breakpoint no-gutters align-end px-8 pt-4">
            <div className="col">
              <div className="row no-gutters">
                {[200, 500, 1000, 10000, 20000, 50000]?.map((res) => {
                  return (
                    <div className="pr-2 pb-2 hidden-md-and-up col col-4">
                      <button
                        type="button"
                        onClick={() => setValue("amount", res)}
                        className={`${watch("amount") == res
                            ? "active-amount-button v-btn--active"
                            : ""
                          } pa-2 full-width theme-button font-weight-bold hidden-md-and-up mobile-amount-button v-btn v-btn--has-bg theme--light v-size--default`}
                        style={{ height: "auto" }}
                      >
                        <span className="v-btn__content">
                          {/* <span
                        className="percent-label-2 ma-0 pa-1 v-chip v-chip--label v-chip--no-color theme--light v-size--x-small"
                        style={{
                          color: "rgb(255, 255, 255) !important",
                          "background-color": "rgb(79, 14, 204) !important",
                        }}
                      >
                        <span className="v-chip__content">+3%</span>
                      </span> */}
                          {res}
                        </span>
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="row pb-3 hidden-md-and-up breakpoint no-gutters align-end px-8 pt-1">
            <div className="col-md-5 col-lg-4 col">
              <hr
                role="separator"
                aria-orientation="horizontal"
                className="v-divider theme--light"
              />
            </div>
          </div>
          <div className="row breakpoint no-gutters align-end px-8">
            <div className="col-md-6 col">
              <div
                className="depo-box mobile"
                light
                remark="fieldHint.promotionRemark"
              >
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">
                    <label
                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                      style={{ float: "left" }}
                    >
                      {t("DepositBonus")}
                      <span className="red--text ml-1">*</span>
                    </label>
                  </div>
                  <div className="col col-2"></div>
                  <div className="col col-12">
                    <div
                      onClick={() => setShow(true)}
                      className={`v-input input-field v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-select ${show
                          ? "v-input--is-focused  v-select--is-menu-active buttonPrimary--text"
                          : ""
                        }`}
                    >
                      <div className="v-input__control">
                        <div
                          role="button"
                          aria-haspopup="listbox"
                          aria-expanded="false"
                          aria-owns="list-614"
                          className="v-input__slot"
                        >
                          <fieldset aria-hidden="true">
                            <legend style={{ width: "0px" }}>
                              <span className="notranslate">​</span>
                            </legend>
                          </fieldset>
                          <div className="v-select__slot">
                            <div className="v-select__selections">
                              <div className="v-select__selection v-select__selection--comma">
                                {isEmpty(offer) ? t("NoBonusSelected") : offer}
                              </div>
                            </div>
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setOffer("");
                              }}
                              className="v-input__append-inner"
                            >
                              <div className="v-input__icon v-input__icon--clear">
                                <button
                                  type="button"
                                  aria-label="clear icon"
                                  className="v-icon notranslate v-icon--link mdi mdi-close theme--light"
                                />
                              </div>
                            </div>
                            <div className="v-input__append-inner">
                              <div className="v-input__icon v-input__icon--append">
                                <i
                                  aria-hidden="true"
                                  className="v-icon notranslate mdi mdi-menu-down theme--light"
                                />
                              </div>
                            </div>
                            <input type="hidden" />
                          </div>
                          <div className="v-menu"></div>
                        </div>
                        <div className="v-text-field__details">
                          <div className="v-messages theme--light">
                            <div className="v-messages__wrapper" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="row pb-5 breakpoint no-gutters align-end px-8">
            <div className="col-md-6 col">
              <button
                type="submit"
                className={`theme-button depo-width black--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default ${isMobile ? "deposit-btn buttonPrimary" : "deposit-btn-desktop"
                  }`}
              >
                <span className="v-btn__content">{t("Deposit")}</span>
              </button>
            </div>
          </div>
        </Form>
      </div>
      {show && (
        <BonusSelect
          options={dataOffer}
          value={offer}
          onChange={handleSelectChange}
          show={show}
          setShow={setShow}
        />
      )}
    </div>
  );
};

export default Deposit;
